<template>
    <div class="container-fluid" id="dvcrud">
        <div class="row">
            <div class="col-md-12">
                <breadcrumb v-bind:bcitens="itensbc" v-bind:mtdcancelar="mtdcancelaredicao"></breadcrumb>
            </div>
            <div class="col-md-12">
                <div id="pnlista" class="card" style="display: none;">
                    <div class="card-header"><span id="titlista">LISTAGEM DE {{ itensbc.item1.titulo }}</span>
                        <router-link to="/">
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                        </router-link>
                    </div>
                    <div class="card-body" style="padding: 10px;">
                        <div class="row">
                            <div class="col-sm-4 col-md-2 col-lg-2">
                                <label for="cbopfiltro">Filtrar:</label>
                                <select name="cbopfiltro" class="form-control form-control-sm" id="cbopfiltro" v-model="pfiltro" @change="mtdlimpar_listagem()">
                                    <option value="0">Código</option>
                                    <option value="1">Descrição</option>
                                </select>
                            </div>
                            <div class="col-sm-8 col-md-6 col-lg-6">
                                <label for="edconteudopesq">Conteúdo da pesquisa:</label>
                                <input id="edconteudopesq" type="text" class="form-control form-control-sm" v-model="pconteudo" @keyup="mtdlimpar_listagem()">
                            </div>
                            <div class="col-6 col-sm-6 col-md-2 col-lg-2">
                                <label for="cbqtdreg">Registros:</label>
                                <select name="cbqtdreg" class="form-control form-control-sm" id="cbqtdreg" v-model="pqtdregistros" @change="mtdlimpar_listagem()">
                                    <option value="10">10</option>
                                    <option value="20">20</option>
                                    <option value="30">30</option>
                                    <option value="40">40</option>
                                    <option value="50">50</option>
                                    <option value="99999999999">Todos</option>
                                </select>
                            </div>
                            <div class="col-6 col-sm-6 col-md-2 col-lg-2">
                                <button type="button" id="btlistar" class="btn btn-primary btn-sm btn-block" @click.prevent="mtdexecutapesquisa()"><i class="fa fa-search"></i> Listar</button>
                            </div>
                            <div class="col-md-12" style="margin-top: 10px;">
                                <vue-bootstrap4-table
                                        :rows="lstclassesimpostos"
                                        :columns="columns"
                                        :config="config"
                                        :classes="classes">
                                    <template slot="empty-results">
                                        <div class="col-md-12 text-center">Sem dados para visualização</div>
                                    </template>
                                    <!-- ícones de ordenação da table -->
                                    <template slot="sort-asc-icon">
                                        <i class="fa-icones-ordenacao fa fa-sort-asc"></i>
                                    </template>
                                    <template slot="sort-desc-icon">
                                        <i class="fa-icones-ordenacao fa fa-sort-desc"></i>
                                    </template>
                                    <template slot="no-sort-icon">
                                        <i class="fa-icones-ordenacao fa fa-unsorted"></i>
                                    </template>                                    
                                    <!--  -->                                    
                                    <template slot="id_f" slot-scope="item">
                                        {{ item.row.id }}
                                    </template>
                                    <template slot="opcoes" slot-scope="item">
                                        <button type="button" class="btn btn-info btn-sm btn-opcrud ajt-btn" @click.prevent="mtdalterar(item.row)"><i class="fa fa-edit"></i></button>
                                        <button type="button" class="btn btn-danger btn-sm btn-opcrud ajt-btn" @click.prevent="mtdexcluir(item.row)"><i class="fa fa-trash"></i></button>
                                    </template>
                                </vue-bootstrap4-table>
                            </div>
                            <div class="col-md-12">
                                <ul class="list-group">
                                    <li class="list-group-item d-flex justify-content-between align-items-center" style="padding: 10px;">
                                        Registros
                                        <span class="badge badge-info badge-pill text-right bdg-qtd-reg-info">{{lstclassesimpostos.length}}</span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="card-footer" style="padding: 10px;">
                        <div class="row">
                            <div class="col-8 col-sm-8 col-md-10 col-lg-10" id="dvpaginacao">
                                <v-pagination
                                        v-model="pagina_atual"
                                        :page-count="pqtd_paginas"
                                        :classes="bootstrapPaginationClasses">
                                </v-pagination>
                            </div>
                            <div class="col-4 col-sm-4 col-md-2 col-lg-2">
                                <button type="button" class="btn btn-success btn-sm btn-block" @click.prevent="mtdnovo()"><i class="fa fa-file"></i> Novo</button>
                            </div>
                        </div>
                    </div>
                </div>
                <div id="pncadastro" class="card" style="display:none;">
                    <div class="card-header"><span>{{itensbc.item2.titulo}}</span>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click.prevent="mtdcancelaredicao()"><span aria-hidden="true">&times;</span></button>
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-sm-12 col-md-2 col-lg-2">
                                <label for="edid">Código:</label>
                                <input type="text" class="form-control form-control-sm" id="edid" v-model="vid" disabled maxlength="4">
                            </div>
                            <div class="col-sm-12 col-md-10 col-lg-10">
                                <label for="eddescricao">*Descrição:</label>
                                <input type="text" v-model="vdescricao" v-bind:disabled="ativadesativa"
                                       class="form-control form-control-sm" id="eddescricao" maxlength="200">
                            </div>
                            <div class="col-sm-12 col-md-6 col-lg-6">
                                <span class="lblselect2">*CFOP({{vidcfop}}):</span>
                                <select id="cbcfop" v-model="vidcfop" v-bind:disabled="ativadesativa"
                                        data-placeholder="Selecione um CFOP" data-allow-clear="true" style="width:100%;">
                                </select>
                            </div>
                            <div class="col-sm-12 col-md-4 col-lg-4">
                                <label for="cbregime">Regime tributário:</label>
                                <select class="form-control form-control-sm" id="cbregime" v-model="vregime" v-bind:disabled="ativadesativa" @change="mtdalteraregime()">
                                    <option value="0">Tributação Normal</option>
                                    <option value="1">Simples Nacional</option>
                                </select>
                            </div>                                                        
                            <div class="col-sm-12 col-md-2 col-lg-2">
                                <label for="cbcalcularnopedido">ST no pedido:</label>
                                <select class="form-control form-control-sm" id="cbcalcularnopedido" v-model="vcalcularnopedido" v-bind:disabled="ativadesativa">
                                    <option value="0">Não</option>
                                    <option value="1">Sim</option>
                                </select>
                            </div>                            
                        </div>
                        <div class="row" style="margin-top: 15px;">
                            <div class="col-md-12">
                                <ul class="nav nav-tabs" role="tablist">
                                    <li class="nav-item">
                                        <a class="nav-link active" data-toggle="tab" href="#dvicms">ICMS</a>
                                    </li>
                                    <li class="nav-item">
                                        <a class="nav-link" data-toggle="tab" href="#dvpiscofins">PIS/COFINS</a>
                                    </li>                                    
                                    <li class="nav-item">
                                        <a class="nav-link" data-toggle="tab" href="#dvipi">IPI</a>
                                    </li>

                                    <li class="nav-item">
                                        <a class="nav-link" data-toggle="tab" href="#dvibscbs">IBS/CBS</a>
                                    </li>

                                    <li class="nav-item">
                                        <a class="nav-link" data-toggle="tab" href="#dvis">IS</a>
                                    </li>

                                    <li class="nav-item">
                                        <a class="nav-link" data-toggle="tab" href="#dvicmsopinter">ICMS em op. inter.</a>
                                    </li>
                                </ul>
                                <div class="tab-content border-left border-right border-bottom" style="padding-top: 15px; padding-bottom: 15px;">
                                    <div id="dvicms" class="container-fluid tab-pane active">
                                        <div class="row">
                                            <div class="col-sm-12 col-md-12 col-lg-12">
                                                <label v-if="parseInt(vregime) === 0" for="cbregime">Código da situação tributária:</label>
                                                <label v-else for="cbregime">CSOSN:</label>
                                                <select class="form-control form-control-sm" id="cbregime" v-model="vcst" v-bind:disabled="ativadesativa" @change="mtdselecionarcamposgrupofiscal(vcst)">
                                                    <option v-for="(item, indice) in lstcst" v-bind:key="indice" v-bind:value="item.codigo">{{item.codigo}} - {{item.descricao}}</option>
                                                </select>
                                            </div>
                                            <div v-show="lstcamposicms.length > 0" class="col-md-12" style="margin-top: 15px;">
                                                <div class="card">
                                                    <div v-if="parseInt(vregime) === 0" class="card-header card-in text-center" style="padding: 5px;">CAMPOS CST {{ vcst }}</div>
                                                    <div v-else class="card-header card-in text-center" style="padding: 5px;">CAMPOS CSOSN {{ vcst }}</div>
                                                    <div class="card-body">
                                                        <div class="row">
                                                            <div class="col-md-12">
                                                                <ul class="list-group">
                                                                    <template v-for="(item, indice) in lstcamposicms" >
                                                                        <template v-if="parseInt(item.habilitarcadastro) === 1">
                                                                            <li v-bind:key="indice" class="list-group-item list-group-item-action lst-campos" v-bind:class="parseInt(item.habilita) === 0 ? 'item-inativo': ''">
                                                                                <div class="row">
                                                                                    <div v-if="item.listajson.length > 0" class="col-md-8">
                                                                                        {{ item.descricao }}
                                                                                    </div>
                                                                                    <div v-else class="col-md-8">
                                                                                        {{ item.descricao }}
                                                                                    </div>                                                                                
                                                                                    <div v-if="item.listajson.length > 0" class="col-md-4">
                                                                                        <select class="form-control form-control-sm" id="cbregime" v-model="item.valor" v-bind:disabled="ativadesativa">
                                                                                            <option v-for="(opcao, indice) in item.listajson" v-bind:key="indice" v-bind:value="opcao.id">{{opcao.descricao}}</option>
                                                                                        </select>                                                                                    
                                                                                    </div>
                                                                                    <template v-else>
                                                                                        <div class="col-md-2">
                                                                                        </div>
                                                                                        <div class="col-md-2">
                                                                                            <money type="text" class="form-control form-control-sm"
                                                                                                v-model="item.valor" v-bind="money"
                                                                                                data-bv-group=".group" style="text-align:right;" v-bind:disabled="ativadesativa">
                                                                                            </money>
                                                                                        </div>
                                                                                    </template>                                                                                
                                                                                </div>
                                                                            </li>
                                                                        </template>    
                                                                    </template>
                                                                </ul>                                                                
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>                                                
                                            </div>
                                        </div>                                                        
                                    </div>
                                    <div id="dvpiscofins" class="container-fluid tab-pane">
                                        <div class="row">
                                            <div class="col-md-12">
                                                <label for="cbcstpiscofins">Código da situação tributária:</label>
                                                <select class="form-control form-control-sm" id="cbcstpiscofins" v-model="vcstpiscofins" v-bind:disabled="ativadesativa">
                                                    <option v-for="(item, indice) in cstpiscofins" v-bind:key="indice" v-bind:value="item.codigo">{{item.codigo}} - {{item.descricao}}</option>
                                                </select>                                                
                                            </div>
                                            <div class="col-sm-12 col-md-3 col-lg-3">
                                                <label for="edppis">Alíquota PIS:</label>
                                                <money type="text" class="form-control form-control-sm" id="edppis"
                                                        v-model="vppis" v-bind="money" v-bind:disabled="ativadesativa" 
                                                        data-bv-group=".group" style="text-align:right;">
                                                </money>
                                            </div>                                             
                                            <div class="col-sm-12 col-md-3 col-lg-3">
                                                <label for="edppisst">Alíquota PIS ST:</label>
                                                <money type="text" class="form-control form-control-sm" id="edppisst"
                                                        v-model="vppisst" v-bind="money" v-bind:disabled="ativadesativa" 
                                                        data-bv-group=".group" style="text-align:right;">
                                                </money>
                                            </div>
                                            <div class="col-sm-12 col-md-3 col-lg-3">
                                                <label for="edpcofins">Alíquota COFINS:</label>
                                                <money type="text" class="form-control form-control-sm" id="edpcofins"
                                                        v-model="vpcofins" v-bind="money" v-bind:disabled="ativadesativa" 
                                                        data-bv-group=".group" style="text-align:right;">
                                                </money>
                                            </div>                                             
                                            <div class="col-sm-12 col-md-3 col-lg-3">
                                                <label for="edpcofinsst">Alíquota COFINS ST:</label>
                                                <money type="text" class="form-control form-control-sm" id="edpcofinsst"
                                                        v-model="vpcofinsst" v-bind="money" v-bind:disabled="ativadesativa" 
                                                        data-bv-group=".group" style="text-align:right;">
                                                </money>
                                            </div>                                                                                                                                  
                                        </div>
                                    </div>
                                    <div id="dvipi" class="container-fluid tab-pane">
                                        <div class="row">
                                            <div class="col-md-12">
                                                <label for="cbcstipi">Código da situação tributária:</label>
                                                <select class="form-control form-control-sm" id="cbcstpipi" v-model="vcstipi" v-bind:disabled="ativadesativa">
                                                    <option v-for="(item, indice) in cstipi" v-bind:key="indice" v-bind:value="item.codigo">{{item.codigo}} - {{item.descricao}}</option>
                                                </select>                                                
                                            </div>
                                            <div class="col-sm-12 col-md-3 col-lg-3">
                                                <label for="edpipi">Alíquota IPI:</label>
                                                <money type="text" class="form-control form-control-sm" id="edpipi"
                                                        v-model="vpipi" v-bind="money" v-bind:disabled="ativadesativa" 
                                                        data-bv-group=".group" style="text-align:right;">
                                                </money>
                                            </div>
                                            <div class="col-sm-12 col-md-2 col-lg-2">
                                                <label for="edcenq">Código de enquadramento:</label>
                                                <input type="text" class="form-control form-control-sm" id="edcenq"
                                                    v-model="vcenq" v-bind:disabled="ativadesativa"
                                                    data-bv-group=".group" maxlength="3">
                                            </div>                                                                                         
                                        </div>
                                    </div> 
                                    <div id="dvicmsopinter" class="container-fluid tab-pane">
                                        <div class="row">
                                            <div class="col-sm-12 col-md-5 col-lg-5">
                                                <label for="edvpfcpufdedt">Percentual ICMS relativo ao FCP na UF do destino:</label>
                                                <money type="text" class="form-control form-control-sm" id="edvpfcpufdedt"
                                                        v-model="vpfcpufdedt" v-bind="money" v-bind:disabled="ativadesativa" 
                                                        data-bv-group=".group" style="text-align:right;">
                                                </money>
                                            </div>
                                            <div class="col-sm-12 col-md-4 col-lg-4">
                                                <label for="edvbcufdest">Valor da base de cálculo na UF do destinatário:</label>
                                                <money type="text" class="form-control form-control-sm" id="edvbcufdest"
                                                        v-model="vbcufdest" v-bind="money" v-bind:disabled="ativadesativa" 
                                                        data-bv-group=".group" style="text-align:right;">
                                                </money>
                                            </div>
                                            <div class="col-sm-12 col-md-3 col-lg-3">
                                                <label for="edvpicmsufdest">Aliq. interna da UF do destinatário:</label>
                                                <money type="text" class="form-control form-control-sm" id="edvpicmsufdest"
                                                        v-model="vpicmsufdest" v-bind="money" v-bind:disabled="ativadesativa" 
                                                        data-bv-group=".group" style="text-align:right;">
                                                </money>
                                            </div>
                                            <div class="col-md-12">
                                                <label for="cbvpicmsinter">Aliq. interestadual:</label>
                                                <select class="form-control form-control-sm" id="cbvpicmsinter" v-model="vpicmsinter" v-bind:disabled="ativadesativa">
                                                    <option value="0"></option>
                                                    <option value="1">4% aliquota interestadual para produtos importados</option>
                                                    <option value="2">7% para estados do sul e sudeste (exceto ES), destinados para estados do norte e nordeste ou ES</option>
                                                    <option value="3">12% para os demais casos</option>
                                                </select>                                                
                                            </div>
                                            <div class="col-md-12">
                                                <label for="cbvpimsinterpart">Percentual provisório de partilha:</label>
                                                <select class="form-control form-control-sm" id="cbvpimsinterpart" v-model="vpimsinterpart" v-bind:disabled="ativadesativa">
                                                    <option value="0"></option>
                                                    <option value="1">40% em 2016</option>
                                                    <option value="2">60% em 2017</option>
                                                    <option value="3">80% em 2018</option>
                                                    <option value="4">100% a partir de 2019</option>
                                                </select>                                                
                                            </div>
                                            <div class="col-sm-12 col-md-4 col-lg-4">
                                                <label for="edvicmsufdest">Valor do ICMS de partilha para UF do destinatário:</label>
                                                <money type="text" class="form-control form-control-sm" id="edvicmsufdest"
                                                        v-model="vicmsufdest" v-bind="money" v-bind:disabled="ativadesativa" 
                                                        data-bv-group=".group" style="text-align:right;">
                                                </money>
                                            </div> 
                                            <div class="col-sm-12 col-md-4 col-lg-4">
                                                <label for="edvicmsufremet">Valor do ICMS de partilha para UF do remetente:</label>
                                                <money type="text" class="form-control form-control-sm" id="edvicmsufremet"
                                                        v-model="vicmsufremet" v-bind="money" v-bind:disabled="ativadesativa" 
                                                        data-bv-group=".group" style="text-align:right;">
                                                </money>
                                            </div>  
                                            <div class="col-sm-12 col-md-4 col-lg-4">
                                                <label for="edvfcpufdest">Valor do ICMS relativo ao FCP da UF de destino:</label>
                                                <money type="text" class="form-control form-control-sm" id="edvfcpufdest"
                                                        v-model="vfcpufdest" v-bind="money" v-bind:disabled="ativadesativa" 
                                                        data-bv-group=".group" style="text-align:right;">
                                                </money>
                                            </div>                                                                          
                                        </div>
                                    </div>  
                                    
                                    <div id="dvibscbs" class="container-fluid tab-pane ">
                                        <div class="row">
                                            <div class="col-sm-12 col-md-12 col-lg-12">
                                                <label  for="cbcstcbs">Código da situação tributária:</label>
                                              
                                                <select class="form-control form-control-sm" id="cbcstcbs" v-model="vcstcbs" v-bind:disabled="ativadesativa" @change="mtdselecionarcamposgrupofiscalcbs(vcstcbs)">
                                                    <option value="">Selecione...</option>
                                                    <option v-for="(item, indice) in lstcstcbs" v-bind:key="indice" v-bind:value="item.codigo">{{item.codigo}} - {{item.descricao}}</option>
                                                </select>
                                            </div>


                                            <div class="col-sm-12 col-md-12 col-lg-12">
                                                <label  for="cbclasstrib">Classificação:</label>
                                              
                                                <select class="form-control form-control-sm" id="cbclasstrib" v-model="vclasstrib" v-bind:disabled="ativadesativa">
                                                    <option value="">Selecione...</option>
                                                    <option v-for="(item, indice) in lstclasstrib" v-bind:key="indice" v-bind:value="item.codigo">{{item.codigo}} - {{item.descricao}}</option>
                                                </select>
                                            </div>

                                            <div class="col-12">
                                                <div class="row" >
                                                    <div class="col-md-12" style="margin-top: 15px;">

                                                        <ul class="nav nav-tabs" role="tablist">

                                                            <li class="nav-item">
                                                                <a class="nav-link active" data-toggle="tab" href="#dviniciocbs">Principal</a>
                                                            </li>

                                                            <li class="nav-item">
                                                                <a class="nav-link " data-toggle="tab" href="#dvtribregular">Tributação regular</a>
                                                            </li>

                                                            <li class="nav-item">
                                                                <a class="nav-link " data-toggle="tab" href="#dvcredpresumido">Crédito presumido</a>
                                                            </li>

                                                            <li class="nav-item">
                                                                <a class="nav-link " data-toggle="tab" href="#dvcompragov">Compra governamental</a>
                                                            </li>
                                                            
                                                        </ul>

                                                        
                                                        <div class="tab-content border-left border-right border-bottom" style="padding-top: 15px; padding-bottom: 15px;">
                                                            
                                                            <div id="dviniciocbs" class="container-fluid tab-pane active">
                                                                <div class="row">
                                                                    <div v-show="lstcamposcbs.length > 0" class="col-md-12" style="margin-top: 15px;">
                                                                        <div class="card">
                                                                
                                                                            <div class="card-header card-in text-center" style="padding: 5px;">
                                                                                CAMPOS CST {{ vcstcbs }} (REFORMA TRIBUTÁRIA 2025) 
                                                                            </div>
                                                                            <div class="card-body">
                                                                                <div class="row">
                                                                                    <div class="col-md-12">
                                                                                        <ul class="list-group">
                                                                                            <template v-for="(item, indice) in lstcamposcbs" >
                                                                                                <template v-if="parseInt(item.habilitarcadastro) === 1">
                                                                                                    <li v-bind:key="indice" class="list-group-item list-group-item-action lst-campos" v-bind:class="parseInt(item.habilita) === 0 ? 'item-inativo': ''">
                                                                                                        <div class="row">
                                                                                                            <div v-if="item.listajson.length > 0" class="col-md-8">
                                                                                                                {{ item.descricao }}
                                                                                                            </div>
                                                                                                            <div v-else class="col-md-8">
                                                                                                                {{ item.descricao }}
                                                                                                            </div>                                                                                
                                                                                                            <div v-if="item.listajson.length > 0" class="col-md-4">
                                                                                                                <select class="form-control form-control-sm" id="cbregime" v-model="item.valor" v-bind:disabled="ativadesativa">
                                                                                                                    <option v-for="(opcao, indice) in item.listajson" v-bind:key="indice" v-bind:value="opcao.id">{{opcao.descricao}}</option>
                                                                                                                </select>                                                                                    
                                                                                                            </div>
                                                                                                            <template v-else>
                                                                                                                <div class="col-md-2">
                                                                                                                </div>
                                                                                                                <div class="col-md-2">
                                                                                                                    <money type="text" class="form-control form-control-sm"
                                                                                                                        v-model="item.valor" v-bind="money"
                                                                                                                        data-bv-group=".group" style="text-align:right;" v-bind:disabled="ativadesativa">
                                                                                                                    </money>
                                                                                                                </div>
                                                                                                            </template>                                                                                
                                                                                                        </div>
                                                                                                    </li>
                                                                                                </template>    
                                                                                            </template>
                                                                                        </ul>                                                                
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>                                                
                                                                    </div>
                                                                </div>
                                                            </div> 
                                                            
                                                            
                                                           
                                                            <div id="dvtribregular" class="container-fluid tab-pane">
                                                                <div class="row">
                                                                    <div class="card">
                                                                        <div class="card-header card-in text-center" style="padding: 5px;">
                                                                            TRIBUTAÇÃO REGULAR
                                                                        </div>
                                                                        <div class="card-body">
                                                                            <div class="row">    
                                                                                <div class="col-sm-12 col-md-12 col-lg-12">
                                                                                    <label  for="cbcstcbs">Código da situação tributária:</label>
                                                                                
                                                                                    <select class="form-control form-control-sm" id="cbcsttribregular" v-model="vcstreg" @change="mtdmudaclasstribreg(vcstreg)" v-bind:disabled="ativadesativa" >
                                                                                        <option value="">Selecione...</option>
                                                                                        <option v-for="(item, indice) in lstcstcbs" v-bind:key="indice" v-bind:value="item.codigo">{{item.codigo}} - {{item.descricao}}</option>
                                                                                    </select>
                                                                                </div>   
                                                                                
                                                                                
                                                                                <div class="col-sm-12 col-md-12 col-lg-12">
                                                                                    <label  for="cbclasstrib">Classificação:</label>
                                                                                
                                                                                    <select class="form-control form-control-sm" id="cbclasstrib" v-model="vclasstribreg" v-bind:disabled="ativadesativa">
                                                                                        <option value="">Selecione...</option>
                                                                                        <option v-for="(item, indice) in lstclasstribreg" v-bind:key="indice" v-bind:value="item.codigo">{{item.codigo}} - {{item.descricao}}</option>
                                                                                    </select>
                                                                                </div>

                                                                                <div class="col-sm-12 col-md-4 col-lg-4">
                                                                                    <label for="edpaliqefetregibsub">Alíquota Efetiva IBS UF:</label>
                                                                                    <money
                                                                                        type="text"
                                                                                        class="form-control form-control-sm"
                                                                                        id="edpaliqefetregibsub"
                                                                                        v-model="vpAliqEfetRegIBSUF"
                                                                                        v-bind="money"
                                                                                        v-bind:disabled="ativadesativa"
                                                                                        data-bv-group=".group"
                                                                                        style="text-align:right;"
                                                                                    ></money>
                                                                                </div>
                                                                                <div class="col-sm-12 col-md-4 col-lg-4">
                                                                                    <label for="edpaliqefetregibsmun">Alíquota Efetiva IBS Município:</label>
                                                                                    <money
                                                                                        type="text"
                                                                                        class="form-control form-control-sm"
                                                                                        id="edpaliqefetregibsmun"
                                                                                        v-model="vpAliqEfetRegIBSMun"
                                                                                        v-bind="money"
                                                                                        v-bind:disabled="ativadesativa"
                                                                                        data-bv-group=".group"
                                                                                        style="text-align:right;"
                                                                                    ></money>
                                                                                </div>
                                                                                <div class="col-sm-12 col-md-4 col-lg-4">
                                                                                    <label for="edpaliqefetregcbs">Alíquota Efetiva CBS:</label>
                                                                                    <money
                                                                                        type="text"
                                                                                        class="form-control form-control-sm"
                                                                                        id="edpaliqefetregcbs"
                                                                                        v-model="vpAliqEfetRegCBS"
                                                                                        v-bind="money"
                                                                                        v-bind:disabled="ativadesativa"
                                                                                        data-bv-group=".group"
                                                                                        style="text-align:right;"
                                                                                    ></money>
                                                                                </div>
                                                                            </div>       
                                                                        </div>               
                                                                    </div>
                                                                </div>
                                                            </div>


                                                            <div id="dvcredpresumido" class="container-fluid tab-pane">
                                                                <div class="row">
                                                                    <div class="col-12">
                                                                        <div class="card">
                                                                            <div class="card-header card-in text-center" style="padding: 5px;">
                                                                                IBS
                                                                            </div>
                                                                            <div class="card-body">
                                                                                <div class="row">
                                                                                    <div class="col-md-12">
                                                                                        <label  for="cbcstcbs">CST crédito presumido:</label>
                                                                                        <select class="form-control form-control-sm" id="cbcstcbs" v-model="vcstcredpresumidoIBS" v-bind:disabled="ativadesativa" >
                                                                                            <option v-for="(item, indice) in lstcstcredpresumido" v-bind:key="indice" v-bind:value="item.codigo">{{item.codigo}} - {{item.descricao}}</option>
                                                                                        </select>
                                                                                    </div>


                                                                                    <div class="col-sm-12 col-md-6 col-lg-6">
                                                                                        <label for="edvpCredPresIBS">Valor Crédito Presumido IBS:</label>
                                                                                        <money
                                                                                            type="text"
                                                                                            class="form-control form-control-sm"
                                                                                            id="edvpCredPresIBS"
                                                                                            v-model="vpCredPresIBS"
                                                                                            v-bind="money"
                                                                                            v-bind:disabled="ativadesativa"
                                                                                            data-bv-group=".group"
                                                                                            style="text-align:right;"
                                                                                        ></money>
                                                                                    </div>
                                                                                    <div class="col-sm-12 col-md-6 col-lg-6">
                                                                                        <label for="edvCredPresCondSuspIBS">Valor Crédito Presumido Cond. Susp. IBS:</label>
                                                                                        <money
                                                                                            type="text"
                                                                                            class="form-control form-control-sm"
                                                                                            id="edvCredPresCondSuspIBS"
                                                                                            v-model="vCredPresCondSuspIBS"
                                                                                            v-bind="money"
                                                                                            v-bind:disabled="ativadesativa"
                                                                                            data-bv-group=".group"
                                                                                            style="text-align:right;"
                                                                                        ></money>
                                                                                    </div>

                                                                                </div>       
                                                                            </div>               
                                                                        </div>
                                                                    </div>
                                                                </div>


                                                                <div class="row">
                                                                    <div class="col-12">
                                                                        <div class="card">
                                                                            <div class="card-header card-in text-center" style="padding: 5px;">
                                                                                CBS
                                                                            </div>
                                                                            <div class="card-body">
                                                                                <div class="row">
                                                                                    
                                                                                        <div class="col-md-12">
                                                                                            <label  for="cbcstcbs">CST crédito presumido:</label>
                                                                                            <select class="form-control form-control-sm" id="cbcstcbs" v-model="vcstcredpresumidoCBS" v-bind:disabled="ativadesativa" >
                                                                                                <option v-for="(item, indice) in lstcstcredpresumido" v-bind:key="indice" v-bind:value="item.codigo">{{item.codigo}} - {{item.descricao}}</option>
                                                                                            </select>
                                                                                        </div>



                                                                                        <div class="col-sm-12 col-md-6 col-lg-6">
                                                                                            <label for="edvpCredPresCBS">Valor Crédito Presumido CBS:</label>
                                                                                            <money
                                                                                                type="text"
                                                                                                class="form-control form-control-sm"
                                                                                                id="edvpCredPresCBS"
                                                                                                v-model="vpCredPresCBS"
                                                                                                v-bind="money"
                                                                                                v-bind:disabled="ativadesativa"
                                                                                                data-bv-group=".group"
                                                                                                style="text-align:right;"
                                                                                            ></money>
                                                                                        </div>

                                                                                        <div class="col-sm-12 col-md-6 col-lg-6" >
                                                                                            <label for="edvCredPresCondSuspCBS">Valor Crédito Presumido Cond. Susp. CBS:</label>
                                                                                            <money
                                                                                                type="text"
                                                                                                class="form-control form-control-sm"
                                                                                                id="edvCredPresCondSuspCBS"
                                                                                                v-model="vCredPresCondSuspCBS"
                                                                                                v-bind="money"
                                                                                                v-bind:disabled="ativadesativa"
                                                                                                data-bv-group=".group"
                                                                                                style="text-align:right;"
                                                                                            ></money>
                                                                                        </div>
                                                                                </div>       
                                                                            </div>               
                                                                        </div>
                                                                    </div>
                                                                </div>


                                                                <div class="row">
                                                                    <div class="col-12">
                                                                        <div class="card">
                                                                            <div class="card-header card-in text-center" style="padding: 5px;">
                                                                                ZFM
                                                                            </div>
                                                                            <div class="card-body">
                                                                                <div class="row">
                                                                                    <div class="col-md-12">
                                                                                        <label for="cbtpCredPresIBSZFM">Tipo Crédito Presumido ZFM:</label>
                                                                                        <select
                                                                                            class="form-control form-control-sm"
                                                                                            id="cbtpCredPresIBSZFM"
                                                                                            v-model="tpCredPresIBSZFM"
                                                                                            v-bind:disabled="ativadesativa"
                                                                                        >
                                                                                            <option value=""></option>
                                                                                            <option value="N">Não</option>
                                                                                            <option value="S">Sim</option>
                                                                                        </select>
                                                                                    </div>
                                                                                </div>       
                                                                            </div>               
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <div id="dvcompragov" class="container-fluid tab-pane">
                                                                <div class="row">
                                                                    <div class="col-12">
                                                                        <div class="card">
                                                                            <div class="card-header card-in text-center" style="padding: 5px;">
                                                                                Compra Governamental
                                                                            </div>
                                                                            <div class="card-body">
                                                                                <div class="row">
                                                                                    
                                                                                    <div class="col-sm-12 col-md-4 col-lg-4">
                                                                                        <label for="edvpAliqIBSUFGov">Alíquota IBS UF (Compra Gov.):</label>
                                                                                        <money
                                                                                            type="text"
                                                                                            class="form-control form-control-sm"
                                                                                            id="edvpAliqIBSUFGov"
                                                                                            v-model="vpAliqIBSUFGov"
                                                                                            v-bind="money"
                                                                                            v-bind:disabled="ativadesativa"
                                                                                            data-bv-group=".group"
                                                                                            style="text-align:right;"
                                                                                        ></money>
                                                                                    </div>
                                                                                    <div class="col-sm-12 col-md-4 col-lg-4">
                                                                                        <label for="edvpAliqIBSMunGov">Alíquota IBS Município (Compra Gov.):</label>
                                                                                        <money
                                                                                            type="text"
                                                                                            class="form-control form-control-sm"
                                                                                            id="edvpAliqIBSMunGov"
                                                                                            v-model="vpAliqIBSMunGov"
                                                                                            v-bind="money"
                                                                                            v-bind:disabled="ativadesativa"
                                                                                            data-bv-group=".group"
                                                                                            style="text-align:right;"
                                                                                        ></money>
                                                                                    </div>
                                                                                    <div class="col-sm-12 col-md-4 col-lg-4">
                                                                                        <label for="edvpAliqCBS">Alíquota CBS (Compra Gov.):</label>
                                                                                        <money
                                                                                            type="text"
                                                                                            class="form-control form-control-sm"
                                                                                            id="edvpAliqCBS"
                                                                                            v-model="vpAliqCBS"
                                                                                            v-bind="money"
                                                                                            v-bind:disabled="ativadesativa"
                                                                                            data-bv-group=".group"
                                                                                            style="text-align:right;"
                                                                                        ></money>
                                                                                    </div>
                                                                                   
                                                                                </div>       
                                                                            </div>               
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>                                                        
                                    </div>

                                    <div id="dvis" class="container-fluid tab-pane">
                                        <div class="row">

                                            <!-- até então não saiu a lista da situação tributária (IS) -->

                                            <!-- <div class="col-md-12">
                                                <label for="cbcstipi">Código da situação tributária (IS) :</label>
                                                <select class="form-control form-control-sm" id="cbcstpipi" v-model="vcstis" v-bind:disabled="ativadesativa">
                                                    <option v-for="(item, indice) in cstis" v-bind:key="indice" v-bind:value="item.codigo">{{item.codigo}} - {{item.descricao}}</option>
                                                </select>                                                
                                            </div> -->
                                            <div class="col-sm-12 col-md-12">
                                                <label for="edcenq">Código da situação tributária (IS) :</label>
                                                <input type="text" class="form-control form-control-sm" id="edcenq"
                                                    v-model="vcstis" v-bind:disabled="ativadesativa"
                                                    data-bv-group=".group" maxlength="3">
                                            </div> 


                                            <div class="col-sm-12 col-md-3 col-lg-3">
                                                <label for="edpis">Alíquota IS:</label>
                                                <money type="text" class="form-control form-control-sm" id="edpis"
                                                        v-model="vpis" v-bind="money" v-bind:disabled="ativadesativa" 
                                                        data-bv-group=".group" style="text-align:right;">
                                                </money>
                                            </div>

                                            <div class="col-sm-12 col-md-9 col-lg-9">
                                                <label for="edpisep">Alíquota específica por unidade de medida apropriada:</label>
                                                <money type="text" class="form-control form-control-sm" id="edpisep"
                                                        v-model="vpisesp" v-bind="money" v-bind:disabled="ativadesativa" 
                                                        data-bv-group=".group" style="text-align:right;">
                                                </money>
                                            </div>
                                                                                      
                                        </div>
                                    </div> 
    
                                </div>    
                            </div>
                        </div>                      
                    </div>
                    <div class="card-footer">
                        <div class="row">
                            <div class="col-sm-8">
                                <h5 style="font-size: 16px; color: #545b62; margin-top: 5px;"><strong>Campos com asterisco(*) devem ser informados</strong>.</h5>
                            </div>
                            <div class="col-sm-2">
                                <button id="btgravar" v-if="(opcrud == 1)" type="button" @click.prevent="mtdgravar()"
                                        v-bind:disabled="validou" class="btn btn-primary btn-sm"
                                        style="width:100%; margin-bottom:10px;"><i class="fa fa-check"></i> Gravar
                                </button>
                                <button id="btgravar" v-else-if="(opcrud == 2)" type="button" @click.prevent="mtdgravar()"
                                        v-bind:disabled="validou" class="btn btn-primary btn-sm"
                                        style="width:100%; margin-bottom:10px;"><i class="fa fa-check"></i> Alterar
                                </button>
                                <button id="btgravar" v-else-if="(opcrud == 3)" type="button" @click.prevent="mtdgravar()"
                                        v-bind:disabled="validou" class="btn btn-primary btn-sm"
                                        style="width:100%; margin-bottom:10px;"><i class="fa fa-check"></i> Excluir
                                </button>
                            </div>
                            <div class="col-sm-2">
                                <button type="button" @click.prevent="mtdcancelaredicao()" class="btn btn-secondary btn-sm" style="width:100%">
                                    <i class="fa fa-close"></i> Cancelar
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import BreadCrumb from '../components/cmpbreadcrumb.vue'
    import VueBootstrap4Table from 'vue-bootstrap4-table'
    import vPagination from 'vue-plain-pagination'
    import util from '../utilitarios/util.js'

    export default {
        name: 'cadclassesimpostos',
        components:{
            VueBootstrap4Table,
            vPagination,
            'breadcrumb' : BreadCrumb
        },
        data: function() {
            return {
                lstclassesimpostos  : [],
                pfiltro      : 1,
                pconteudo    : '',
                pqtdregistros: 10,
                pqtd_paginas : 1,
                pagina_atual : 1,
                pqtd_total_registros: 0,

                cstnormal   : [
                    {codigo : '00', descricao : 'Tributada integralmente'},
                    {codigo : '02', descricao : 'Tributação Monofásica própria sobre Combustíveis'},
                    {codigo : '10', descricao : 'Tributada e com cobrança do ICMS por substituição tributária'},
                    {codigo : '15', descricao : 'Tributação Monofásica própria e com responsabilidade pela retenção sobre Combustíveis'},
                    {codigo : '20', descricao : 'Com redução de base de cálculo'},
                    {codigo : '30', descricao : 'Isenta ou não tributada e com cobrança do ICMS por substituição tributária'},
                    {codigo : '40', descricao : 'Isenta'},
                    {codigo : '41', descricao : 'Não tributada'},
                    {codigo : '50', descricao : 'Suspensão'},
                    {codigo : '51', descricao : 'Diferimento'},
                    {codigo : '53', descricao : 'Tributação Monofásica sobre Combustíveis com recolhimento diferido'},
                    {codigo : '60', descricao : 'ICMS cobrado anteriormente por substituição tributária'},
                    {codigo : '61', descricao : 'Tributação Monofásica sobre Combustíveis cobrada anteriormente'},
                    {codigo : '70', descricao : 'Com redução de base de cálculo e cobrança do ICMS por substituição tributária'},
                    {codigo : '90', descricao : 'Outros'}
                ],
                cstsimples  : [
                    {codigo : '101', descricao : 'Tributada pelo Simples Nacional com permissão de crédito'},
                    {codigo : '102', descricao : 'Tributada pelo Simples Nacional sem permissão de crédito'},
                    {codigo : '103', descricao : 'Isenção do ICMS no Simples Nacional para faixa de receita bruta'},
                    {codigo : '201', descricao : 'Tributada pelo Simples Nacional com permissão de crédito e com cobrança do ICMS por substituição tributária'},
                    {codigo : '202', descricao : 'Tributada pelo Simples Nacional sem permissão de crédito e com cobrança do ICMS por substituição tributária'},
                    {codigo : '203', descricao : 'Isenção do ICMS no Simples Nacional para faixa de receita bruta e com cobrança do ICMS por substituição tributária'},
                    {codigo : '300', descricao : 'Imune'},
                    {codigo : '400', descricao : 'Não tributada pelo Simples Nacional'},
                    {codigo : '500', descricao : 'ICMS cobrado anteriormente por substituição tributária (substituído) ou por antecipação'},
                    {codigo : '900', descricao : 'Outros'}
                ],
                cstpiscofins : [
                    {codigo : '01', descricao : 'Operação Tributável com Alíquota Básica'},
                    {codigo : '02', descricao : 'Operação Tributável com Alíquota Diferenciada'},
                    {codigo : '03', descricao : 'Operação Tributável com Alíquota por Unidade de Medida de Produto'},
                    {codigo : '04', descricao : 'Operação Tributável Monofásica - Revenda a Alíquota Zero'},
                    {codigo : '05', descricao : 'Operação Tributável por Substituição Tributária'},
                    {codigo : '06', descricao : 'Operação Tributável a Alíquota Zero'},
                    {codigo : '07', descricao : 'Operação Isenta da Contribuição'},
                    {codigo : '08', descricao : 'Operação sem Incidência da Contribuição'},
                    {codigo : '09', descricao : 'Operação com Suspensão da Contribuição'},
                    {codigo : '49', descricao : 'Outras Operações de Saída'},
                    {codigo : '50', descricao : 'Operação com Direito a Crédito - Vinculada Exclusivamente a Receita Tributada no Mercado Interno'},
                    {codigo : '51', descricao : 'Operação com Direito a Crédito - Vinculada Exclusivamente a Receita Não-Tributada no Mercado Interno'},
                    {codigo : '52', descricao : 'Operação com Direito a Crédito - Vinculada Exclusivamente a Receita de Exportação'},
                    {codigo : '53', descricao : 'Operação com Direito a Crédito - Vinculada a Receitas Tributadas e Não-Tributadas no Mercado Interno'},
                    {codigo : '54', descricao : 'Operação com Direito a Crédito - Vinculada a Receitas Tributadas e Não-Tributadas no Mercado Interno'},
                    {codigo : '55', descricao : 'Operação com Direito a Crédito - Vinculada a Receitas Não Tributadas no Mercado Interno e de Exportação'},
                    {codigo : '56', descricao : 'Operação com Direito a Crédito - Vinculada a Receitas Tributadas e Não-Tributadas no Mercado Interno e de Exportação'},
                    {codigo : '60', descricao : 'Crédito Presumido - Operação de Aquisição Vinculada Exclusivamente a Receita Tributada no Mercado Interno'},
                    {codigo : '61', descricao : 'Crédito Presumido - Operação de Aquisição Vinculada Exclusivamente a Receita Não-Tributada no Mercado Interno'},
                    {codigo : '62', descricao : 'Crédito Presumido - Operação de Aquisição Vinculada Exclusivamente a Receita de Exportação'},
                    {codigo : '63', descricao : 'Crédito Presumido - Operação de Aquisição Vinculada a Receitas Tributadas e Não-Tributadas no Mercado Interno'},
                    {codigo : '64', descricao : 'Crédito Presumido - Operação de Aquisição Vinculada a Receitas Tributadas no Mercado Interno e de Exportação'},
                    {codigo : '65', descricao : 'Crédito Presumido - Operação de Aquisição Vinculada a Receitas Não-Tributadas no Mercado Interno e de Exportação'},
                    {codigo : '66', descricao : 'Crédito Presumido - Operação de Aquisição Vinculada a Receitas Tributadas e Não-Tributadas no Mercado Interno e de Exportação'},
                    {codigo : '67', descricao : 'Crédito Presumido - Outras Operações'},
                    {codigo : '70', descricao : 'Operação de Aquisição sem Direito a Crédito'},
                    {codigo : '71', descricao : 'Operação de Aquisição com Isenção'},
                    {codigo : '72', descricao : 'Operação de Aquisição com Suspensão'},
                    {codigo : '73', descricao : 'Operação de Aquisição a Alíquota Zero'},
                    {codigo : '74', descricao : 'Operação de Aquisição sem Incidência da Contribuição'},
                    {codigo : '75', descricao : 'Operação de Aquisição por Substituição Tributária'},
                    {codigo : '98', descricao : 'Outras Operações de Entrada'},
                    {codigo : '99', descricao : 'Outras Operações'}
                ],
                cstipi       : [
                    {codigo : '00', descricao : 'Entrada com Recuperação de Crédito'},
                    {codigo : '01', descricao : 'Entrada Tributada com Alíquota Zero'},
                    {codigo : '02', descricao : 'Entrada Isenta'},
                    {codigo : '03', descricao : 'Entrada Não Tributada'},
                    {codigo : '04', descricao : 'Entrada Imune'},
                    {codigo : '05', descricao : 'Entrada com Suspensão'},
                    {codigo : '49', descricao : 'Outras Entradas'},
                    {codigo : '50', descricao : 'Saída Tributada'},
                    {codigo : '51', descricao : 'Saída Tributável com Alíquota Zero'},
                    {codigo : '52', descricao : 'Saída Isenta'},
                    {codigo : '53', descricao : 'Saída Não Tributada'},
                    {codigo : '54', descricao : 'Saída Imune'},
                    {codigo : '55', descricao : 'Saída com Suspensão'},
                    {codigo : '99', descricao : 'Outras Saídas'}
                ],

        
                // Campos da regorma tibutária 2026
                
                // lista de campos para CBSIBS
                lstcstcbs: [],

                vclasstrib   : '',
                vcstcbs      : '',
                vcstcbsold   : '',
                vclasstribold: '',
                lstclasstrib: [],

                // campos tributação Regular

                vcstreg            : '',
                vclasstribreg      : '',
                vpAliqEfetRegIBSUF : 0,
                vpAliqEfetRegIBSMun: 0,
                vpAliqEfetRegCBS   : 0,


                // campos crédito presumido 
                lstcstcredpresumido    : [
                    {codigo : '01', descricao : 'Crédito presumido da aquisição de bens e serviços de produtor rural e produtor rural integrado não contribuinte, observado o art. 168 da Lei Complementar nº 214, de 2025.'},
                    {codigo : '02', descricao : 'Crédito presumido da aquisição de serviço de transportador autônomo de carga pessoa física não contribuinte, observado o art. 169 da Lei Complementar nº 214, de 2025.'},
                    {codigo : '03', descricao : 'Crédito presumido da aquisição de resíduos e demais materiais destinados à reciclagem, reutilização ou logística reversa adquiridos de pessoa física, cooperativa ou outra forma de organização popular, observado o art. 170 da Lei Complementar nº 214, de 2025.'},
                    {codigo : '04', descricao : 'Crédito presumido da aquisição de bens móveis usados de pessoa física não contribuinte para revenda, observado o art. 171 da Lei Complementar nº 214, de 2025.'},
                    {codigo : '05', descricao : 'Crédito presumido no regime automotivo, observado o art. 310 da Lei Complementar nº 214, de 2025.'},
                    {codigo : '06', descricao : 'Crédito presumido no regime automotivo, observado o art. 311 da Lei Complementar nº 214, de 2025.'},
                    {codigo : '07', descricao : 'Crédito presumido na aquisição por contribuinte na Zona Franca de Manaus, observado o art. 444 da Lei Complementar nº 214, de 2025.'},
                    {codigo : '08', descricao : 'Crédito presumido na aquisição por contribuinte na Zona Franca de Manaus, observado o art. 447 da Lei Complementar nº 214, de 2025.'},
                    {codigo : '09', descricao : 'Crédito presumido na aquisição por contribuinte na Zona Franca de Manaus, observado o art. 447 da Lei Complementar nº 214, de 2025.'},
                    {codigo : '10', descricao : 'Crédito presumido na aquisição por contribuinte na Zona Franca de Manaus, observado o art. 450 da Lei Complementar nº 214, de 2025.'},
                    {codigo : '11', descricao : 'Crédito presumido na aquisição por contribuinte na Área de Livre Comércio, observado o art. 462 da Lei Complementar nº 214, de 2025.'},
                    {codigo : '12', descricao : 'Crédito presumido na aquisição por contribuinte na Área de Livre Comércio, observado o art. 465 da Lei Complementar nº 214, de 2025.'},
                    {codigo : '13', descricao : 'Crédito presumido na aquisição pela indústria na Área de Livre Comércio, observado o art. 467 da Lei Complementar nº 214, de 2025.'},                
                ],

                // IBS

                vcstcredpresumidoIBS  : '00',
                vpCredPresIBS            : 0,
                vCredPresCondSuspIBS     : 0,

                // CBS

                vcstcredpresumidoCBS  : '00',
                vpCredPresCBS            : 0,
                vCredPresCondSuspCBS     : 0,


                // ZFM 
                tpCredPresIBSZFM  : '',
            
            
                // Compra Governamental
                vpAliqIBSUFGov  : 0,
                vpAliqIBSMunGov : 0,
                vpAliqCBS       : 0,

                vcstis          : '000',
                vpis            : 0,
                vpisesp         : 0,



                lstcst              : [],
                //variáveis do crud
                opcrud              :  0,
                vid                 : '',
                vdescricao          : '',
                vidcfop             : null,
                vregime             : 0,
                vcst                : '',
                vcstold             : '', 
                vcstpiscofins       : '01',
                vcstipi             : '99',                              
                vppis               : 0,
                vppisst             : 0,
                vpcofins            : 0,
                vpcofinsst          : 0,
                vpipi               : 0,
                vcenq               : '999',
                // PARTILHA DE ICMS
                vbcufdest           : 0,
                vpfcpufdedt         : 0,
                vpicmsufdest        : 0,
                vpicmsinter         : 0,
                vpimsinterpart      : 0,
                vfcpufdest          : 0,
                vicmsufdest         : 0,
                vicmsufremet        : 0,
                ////////////////////////

                vcalcularnopedido   : 0,
                lstcamposicms       : [],
                lstcamposicmsalt    : [],


                lstcamposcbs        : [],  
                lstcamposcbsalt     : [], 

                //variável para habilitação dos campos
                ativadesativa       : true,
                ativadesativaid     : true,
                money: {
                    decimal         : ',',
                    thousands       : '.',
                    prefix          : '',//aqui colocar o cifrão se for necessário
                    precision       : 2,
                    masked          : false
                },
                bootstrapPaginationClasses: {
                    ul: 'pagination pagination-sm',
                    li: 'page-item',
                    liActive: 'active',
                    liDisable: 'disabled',
                    button: 'page-link'
                },
                itensbc : {
                    item1 : {
                        titulo : 'CLASSES DE IMPOSTOS',
                        ativo  : false
                    },
                    item2 : {
                        titulo : '',
                        ativo  : false
                    }
                },
                columns: [
                    {
                        label: 'Opções',
                        name : 'opcoes',
                        row_text_alignment: "text-center",
                        column_text_alignment: "text-center",
                        row_classes: "def-col-opcoes",
                        sort: false
                    },
                    {
                        label: "Código",
                        name: "id",
                        sort: true,
                        slot_name: "id_f",
                        row_classes: "def-col-cod",
                    },
                    {
                        label: "Descrição",
                        name: "descricao",
                        initial_sort : true,//acrescentar isso na coluna que for iniciar ordenado
                        initial_sort_order: 'asc',
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left"
                    },
                                        {
                        label: "CFOP",
                        name: "idcfop",
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left"
                    }
                ],
                config: {
                    pagination: false,
                    pagination_info: false,
                    card_mode: false,
                    global_search: {
                        visibility: false,
                    },
                    show_refresh_button : false,
                    show_reset_button : false
                },
                classes: {
                    table: "table-bordered table-striped table-sm"
                }
            }
        },
        methods:{
            mtdmudaclasstribreg(idgrupo, resetaclasstrib = true){
                let ind = util.getArrayIndexForKey(this.lstcstcbs, 'codigo', idgrupo);
                this.lstclasstribreg  = this.lstcstcbs[ind].classtrib;
                if (resetaclasstrib){
                    this.vclasstribreg    = this.lstclasstribreg[0].codigo  
                };         
        
            },
            mtdselecionarcamposgrupofiscal(idgrupo){
                if (parseInt(this.opcrud) === 2 && this.vcstold === this.vcst){
                    this.lstcamposicms = this.lstcamposicmsalt;
                    return;
                }        
                var vself       = this;
                let loader      = this.$loading.show();
                let parametros  = [
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',           valor : 'camposgrupofiscal'},
                    {parametro: 'idgrupo',      valor : idgrupo}
                ];
                let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadclassesimpostos.php');
                retorno.then(function (response) {                    
                    vself.lstcamposicms = response.data;
                    loader.hide();           
                }).catch(function (response) {
                    vself.lstcamposicms = [];                    
                    loader.hide();
                });                   
            },
            mtdselecionaclasstribcbs(idgrupo, resetaclasstrib = true){
                let ind = util.getArrayIndexForKey(this.lstcstcbs, 'codigo', idgrupo);
                this.lstclasstrib = this.lstcstcbs[ind].classtrib;
                if (resetaclasstrib){
                    this.vclasstrib    = this.lstclasstrib[0].codigo;
                }
            },
            mtdselecionarcamposgrupofiscalcbs(idgrupo){
                let vself       = this;
                this.mtdselecionaclasstribcbs(idgrupo);

                if (parseInt(this.opcrud) === 2 && this.vcstcbsold === this.vcstcbsold && this.vclasstribold === this.vclasstrib){
                    this.lstcamposcbs = this.lstcamposcbsalt;
                    return;
                } 


                let loader      = this.$loading.show();
                let parametros  = [
                    {parametro: 'idclientesac', valor : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',           valor : 'camposgrupofiscalcbs'},
                    {parametro: 'idgrupo',      valor : idgrupo}
                ];
                let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadclassesimpostos.php');
                retorno.then(function (response) {                    
                    vself.lstcamposcbs = response.data;
                    loader.hide();           
                }).catch(function (response) {
                    vself.lstcamposcbs = [];                    
                    loader.hide();
                });          
            },

            mtdalteraregime(){
                if (parseInt(this.vregime) === 0){
                    this.mtdselecionarcamposgrupofiscal('00');
                }else{
                    this.mtdselecionarcamposgrupofiscal('101');
                }                  
                this.atribuilistacst();
            },
            atribuilistacst(){
                if (parseInt(this.vregime) === 0){
                    this.lstcst = this.cstnormal;
                    this.vcst   = '00';
                }else{
                    this.lstcst = this.cstsimples;
                    this.vcst   = '101';
                }
                setTimeout(() => {
                    this.mtdselecionarcamposgrupofiscal(this.vcst);
                }, 500);                    
            },
            mtdselect2_def(){
                let vself = this;            
                $("#cbcfop").select2({
                        id: function (e) {return e.id},
                        ajax: {
                            url: vself.$store.state.configpaths.pathselect2,
                            dataType: 'json',
                            delay: 250,
                            data: function (params) {
                                return {
                                    q: params.term,
                                    idclientesac : vself.$store.state.filialpadrao.idcliente,
                                    tb: 'tbcfops',
                                    c1: 'id',
                                    c2: 'descricao'
                                };
                            },
                            processResults: function (data) {
                                return {
                                    results: data
                                };
                            },
                            cache: true
                        },
                        //minimumInputLength: 2,
                        theme: 'bootstrap',
                        language: "pt-BR",
                        templateResult: util.formatResult,
                        templateSelection: util.formatSelection
                    }
                ).change(function () {
                    vself.vidcfop = $("#cbcfop").val();
                }); 
                

                //carrega os grupos de tributação do CBS
                let parametros  = [
                    {parametro: 'idclientesac', valor : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',           valor : 'carregacstcbs'}
                ];
                let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadclassesimpostos.php');
                retorno.then(function (response) {
                    vself.lstcstcbs = response.data;
                    
                }).catch(function (response) {
                    vself.lstcstcbs = [];
                });
                

            },
            mtdfiltropesquisa(){
                let rfiltro = '';
                if (parseInt(this.pfiltro) === 0){
                    rfiltro = this.pconteudo === '' ? '' : ' and ci.id="'+this.pconteudo+'"';
                }else{
                    rfiltro = this.pconteudo === '' ? '' : ' and upper(ci.descricao) like upper("'+this.pconteudo+'%")';
                }
                return rfiltro;
            },
            mtdexecutapesquisa(){
                var vself           = this;
                let filtro          = vself.mtdfiltropesquisa();
                this.pagina_atual   = 1;
                let parametros      = [
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',           valor  : 'qtdregistros'},
                    {parametro: 'filtro',       valor  : filtro}
                ];
                let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadclassesimpostos.php');
                retorno.then(function (response) {
                    vself.pqtd_total_registros = parseInt(response.data.qtdregistros);
                    let qtdpg                  = Math.ceil(vself.pqtd_total_registros / vself.pqtdregistros);
                    vself.pqtd_paginas         = qtdpg > 0 ? qtdpg : 1;
                    vself.mtdcarregaclassesimpostos(1);
                }).catch(function (response) {
                    alert('Erro ao consultar registros');
                });
            },
            mtdcarregaclassesimpostos(ipagina){
                var vself       = this;
                let loader      = this.$loading.show();
                let filtro      = vself.mtdfiltropesquisa();
                let parametros  = [
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',           valor : 'listagem'},
                    {parametro: 'filtro',       valor : filtro},
                    {parametro: 'limit',        valor : vself.pqtdregistros},
                    {parametro: 'offset',       valor : (parseInt(ipagina) -1) * parseInt(vself.pqtdregistros)},
                ];
                let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadclassesimpostos.php');
                retorno.then(function (response) {
                    vself.lstclassesimpostos = response.data;
                    loader.hide();
                }).catch(function (response) {
                    vself.lstclassesimpostos = [];
                    loader.hide();
                });
            },
            resetarDados() {
                util.toTop();
                this.lstcamposicms      = [];
                this.lstcamposicmsalt   = [];
                this.vid                = '';
                this.vdescricao         = '';
                this.vidcfop            = null;
                this.vregime            = '0';                  
                this.vcst               = '00';
                this.vcstpiscofins      = '01';
                this.vcstipi            = '99';
                this.vppis              = 0;
                this.vppisst            = 0;
                this.vpcofins           = 0;
                this.vpcofinsst         = 0;
                this.vpipi              = 0;
                this.vcenq              = '999';
                this.vcalcularnopedido  = 0;
                this.vbcufdest          = 0;   
                this.vpfcpufdedt        = 0; 
                this.vpicmsufdest       = 0;
                this.vpicmsinter        = 0;
                this.vpimsinterpart     = 0;
                this.vfcpufdest         = 0;
                this.vicmsufdest        = 0;
                this.vicmsufremet       = 0;

                this.vclasstrib         = '';
                this.vcstcbs            = '';
                this.vcstcbsold         = '';
                this.vclasstribold      = '';
                this.lstclasstrib       = [];


                // campos tributação Regular

                this.vcstreg             = '';
                this.vclasstribreg       = '';
                this.vpAliqEfetRegIBSUF  = 0;
                this.vpAliqEfetRegIBSMun = 0;
                this.vpAliqEfetRegCBS    = 0;


                // IBS

                this.vcstcredpresumidoIBS = '00';
                this.vpCredPresIBS        = 0;
                this.vCredPresCondSuspIBS = 0;

                // CBS

                this.vcstcredpresumidoCBS = '00';
                this.vpCredPresCBS        = 0;
                this.vCredPresCondSuspCBS = 0;


                // ZFM 
                this.tpCredPresIBSZFM     = '';


                // Compra Governamental
                this.vpAliqIBSUFGov       = 0;
                this.vpAliqIBSMunGov      = 0;
                this.vpAliqCBS            = 0;

                // IS
                this.vcstis               = '000';
                this.vpis                 = 0;
                this.vpisesp              = 0;





                if (parseInt(this.opcrud) === 1){
                    this.mtdalteraregime();
                }
                
                $('#cbcfop').val(null).trigger('change');
            },
            mtddefault(){
                $('#pnlista').hide();
                this.resetarDados();
                $('#pncadastro').fadeIn(700);
                this.$nextTick(function () {
                    if (parseInt(this.opcrud) < 3) {
                        $('#eddescricao').focus();
                    }else{
                        $('#btgravar').focus();
                    }
                });
            },
            mtdpreparacrud(op) {
                let vself    = this;
                vself.opcrud = op;
                $('.nav-tabs a[href="#dvicms"]').tab('show');
                vself.mtddefault();
            },
            mtdnovo(){
                if (!util.opcaousuario('001Z.012Z.001Z', this.$store.state.perfilusuario)){
                    this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
                }else {
                    this.itensbc.item2.titulo = "INCLUSÃO DE CLASSE DE IMPOSTO";
                    this.itensbc.item1.ativo = true;
                    this.itensbc.item2.ativo = true;
                    this.ativadesativa = false;
                    this.ativadesativaid = false;
                    this.mtdpreparacrud(1);
                    this.mtdselecionarcamposgrupofiscal('00');
                }
            },
            mtdcancelaredicao(){
                this.itensbc.item1.ativo = false;
                this.itensbc.item2.ativo = false;
                $('#pncadastro').hide();
                $('#pnlista').fadeIn(700);
                $('#edconteudopesq').focus();
                setTimeout(function(){
                    util.toTop();
                }, 200);
            },
            mtdlimpar_listagem() {
                this.lstclassesimpostos = [];
                this.pagina_atual = 1;
                this.filtro = '';
                this.pqtd_total_registros = 0;
                this.pqtd_paginas = 0;
            },
            mtdgravar(){
                let vself = this;
            
                $.confirm({
                    title: 'Confirmação!',
                    content: 'Confirma ' + vself.itensbc.item2.titulo + '?',
                    icon: 'fa fa-question-circle',
                    escapeKey: true,
                    backgroundDismiss: false,
                    escapeKey: 'nao',
                    type: 'dark',
                    typeAnimated: true,
                    buttons: {
                        sim: {
                            text: '<u>S</u>im',
                            keys: ['s', 'S'],
                            btnClass: 'btn-blue',
                            action: function () {
                                $('.btn-blue').prop('disabled', true);
                                vself.mtdregistro();
                            },
                        },
                        nao: {
                            text: '<u>N</u>ão',
                            keys: ['n', 'N'],
                            action: function () {
                                $('#btgravar').focus();
                            }
                        }
                    }
                });
            },
            mtdlocalizaregistro(id){
                var vself       = this;
                let loader      = vself.$loading.show();
                let filtro      = ' and ci.id="'+id+'"';
                let parametros  = [
                    {parametro: 'op',           valor : 'listagem'},
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'filtro',       valor : filtro},
                    {parametro: 'limit',        valor : 1},
                    {parametro: 'offset',       valor : 0},
                ];
                let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadclassesimpostos.php');
                retorno.then(function (response) {
                    loader.hide();
                    vself.mtdigualarcampos(response.data[0]);
                    if (parseInt(vself.opcrud) < 3){
                        $('#eddescricao').focus();
                    }else{
                        $('#btgravar').focus();
                    }
                }).catch(function (response) {
                    loader.hide();
                });
            },
            mtdalterar(item){
                if (!util.opcaousuario('001Z.012Z.002Z', this.$store.state.perfilusuario)){
                    this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
                }else {
                    this.itensbc.item2.titulo = "ALTERAÇÃO DE CLASSE DE IMPOSTO";
                    this.itensbc.item1.ativo = true;
                    this.itensbc.item2.ativo = true;
                    this.ativadesativa = false;
                    this.ativadesativaid = true;
                    this.mtdpreparacrud(2);
                    this.mtdlocalizaregistro(item.id);
                }
            },
            mtdexcluir(item){
                if (!util.opcaousuario('001Z.012Z.003Z', this.$store.state.perfilusuario)){
                    this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
                }else {
                    this.itensbc.item2.titulo = "EXCLUSÃO DE CLASSE DE IMPOSTO";
                    this.itensbc.item1.ativo = true;
                    this.itensbc.item2.ativo = true;
                    this.ativadesativa = true;
                    this.ativadesativaid = true;
                    this.mtdpreparacrud(3);
                    this.mtdlocalizaregistro(item.id);
                }
            },
            mtdigualarcampos(registro){
                let vself = this;
                vself.vid                 = registro.id;
                vself.vdescricao          = registro.descricao;
                vself.vidcfop             = registro.idcfop;
                vself.vregime             = registro.regime;
                if (parseInt(vself.vregime) === 0){
                    vself.lstcst = vself.cstnormal;
                }else{
                    vself.lstcst = vself.cstsimples;
                }
                setTimeout(() => {
                    vself.vcst                = registro.cst;
                    vself.vcstold             = registro.cst;
                    vself.lstcamposicms       = JSON.parse(JSON.stringify(registro.lstcampos));
                    vself.lstcamposicmsalt    = JSON.parse(JSON.stringify(registro.lstcampos));

                    vself.lstcamposcbs        = JSON.parse(JSON.stringify(registro.lstcamposcbs));
                    vself.lstcamposcbsalt     = JSON.parse(JSON.stringify(registro.lstcamposcbs));
                                
                    vself.vcstpiscofins       = registro.cstpiscofins;
                    vself.vcstipi             = registro.cstipi;                              
                    vself.vppis               = registro.ppis;
                    vself.vppisst             = registro.ppisst;
                    vself.vpcofins            = registro.pcofins;
                    vself.vpcofinsst          = registro.pcofinsst;
                    vself.vpipi               = registro.pipi;
                    vself.vcenq               = registro.cenq;
                    vself.vcst                = registro.cst;


                    // refoma tributária 2026
                   
                    vself.vclasstrib         = registro.classtrib;
                    vself.vcstcbs            = registro.cstcbs;
                    vself.vcstcbsold         = registro.cstcbs;

                    if( vself.vclasstrib !== ''){
                        vself.mtdselecionaclasstribcbs(registro.cstcbs, false);
                    }
            
                

                    // campos tributação Regular

                     
                    vself.vcstreg             = registro.cstreg;
                    vself.vclasstribreg       = registro.classtribreg;
                    vself.vpAliqEfetRegIBSUF  = registro.pAliqEfetRegIBSUF;
                    vself.vpAliqEfetRegIBSMun = registro.pAliqEfetRegIBSMun;
                    vself.vpAliqEfetRegCBS    = registro.pAliqEfetRegCBS;

                    if( vself.vclasstribreg !== ''){
                        vself.mtdmudaclasstribreg(registro.cstreg, false);  
                    }

                    // IBS

                    vself.vcstcredpresumidoIBS = registro.cstcredpresumidoIBS;
                    vself.vpCredPresIBS        = registro.pCredPresIBS;
                    vself.vCredPresCondSuspIBS = registro.CredPresCondSuspIBS;

                    // CBS

                    vself.vcstcredpresumidoCBS = registro.cstcredpresumidoCBS;
                    vself.vpCredPresCBS        = registro.pCredPresCBS;
                    vself.vCredPresCondSuspCBS = registro.CredPresCondSuspCBS;

                    // ZFM 
                    vself.tpCredPresIBSZFM     = registro.tpCredPresIBSZFM;

                    // Compra Governamental
                    vself.vpAliqIBSUFGov       = registro.pAliqIBSUFGov;
                    vself.vpAliqIBSMunGov      = registro.pAliqIBSMunGov;
                    vself.vpAliqCBS            = registro.pAliqCBS;


                    // IS
                    vself.vcstis               = registro.cstis;    
                    vself.vpis                 = registro.pis;
                    vself.vpisesp              = registro.pisesp;




                    ///partilha de icms
                    vself.vbcufdest           = registro.vbcufdest;
                    vself.vpfcpufdedt         = registro.vpfcpufdedt;  
                    vself.vpicmsufdest        = registro.vpicmsufdest;
                    vself.vpicmsinter         = registro.vpicmsinter;
                    vself.vpimsinterpart      = registro.vpimsinterpart;
                    vself.vfcpufdest          = registro.vfcpufdest;
                    vself.vicmsufdest         = registro.vicmsufdest;
                    vself.vicmsufremet        = registro.vicmsufremet;


                    vself.vcalcularnopedido   = registro.calcularnopedido;

                    var defcfop    = new Option(registro.desccfop, vself.vidcfop, true, true);
                    $('#cbcfop').append(defcfop).trigger('change'); 
                    if (parseInt(vself.opcrud) < 3){
                        vself.mtdselecionarcamposgrupofiscal(vself.vcst);
                    }
                }, 300);
            },
            mtdregistro(){
                let vself  = this;
                let loader = vself.$loading.show();
                let registrocrud = {
                    'id'                : this.vid,
                    'descricao'         : this.vdescricao,
                    'idcfop'            : this.vidcfop,
                    'regime'            : this.vregime,
                    'cst'               : this.vcst, 
                    'cstpiscofins'      : this.vcstpiscofins,
                    'cstipi'            : this.vcstipi,                              
                    'ppis'              : this.vppis,
                    'ppisst'            : this.vppisst,
                    'pcofins'           : this.vpcofins,
                    'pcofinsst'         : this.vpcofinsst,
                    'pipi'              : this.vpipi,
                    'cenq'              : this.vcenq,
                    'calcularnopedido'  : this.vcalcularnopedido, 
                    'vbcufdest'         : this.vbcufdest,  
                    'vpfcpufdedt'       : this.vpfcpufdedt,
                    'vpicmsufdest'      : this.vpicmsufdest,
                    'vpicmsinter'       : this.vpicmsinter, 
                    'vpimsinterpart'    : this.vpimsinterpart,
                    'vfcpufdest'        : this.vfcpufdest,
                    'vicmsufdest'       : this.vicmsufdest,
                    'vicmsufremet'      : this.vicmsufremet,             
                    'lstcampos'         : this.lstcamposicms,


                    'lstcamposcbs'        : this.lstcamposcbs,

                    'classtrib'           : this.vclasstrib,
                    'cstcbs'              : this.vcstcbs,
                    'cstcbsold'           : this.vcstcbsold,
              

                    // campos tributação Regular
                    'cstreg'              : this.vcstreg,
                    'classtribreg'        : this.vclasstribreg,
                    'pAliqEfetRegIBSUF'   : this.vpAliqEfetRegIBSUF,
                    'pAliqEfetRegIBSMun'  : this.vpAliqEfetRegIBSMun,
                    'pAliqEfetRegCBS'     : this.vpAliqEfetRegCBS,

                    // IBS
                    'cstcredpresumidoIBS' : this.vcstcredpresumidoIBS,
                    'pCredPresIBS'        : this.vpCredPresIBS,
                    'CredPresCondSuspIBS' : this.vCredPresCondSuspIBS,

                    // CBS
                    'cstcredpresumidoCBS' : this.vcstcredpresumidoCBS,
                    'pCredPresCBS'        : this.vpCredPresCBS,
                    'CredPresCondSuspCBS' : this.vCredPresCondSuspCBS,

                    //IS
                    'cstis'               : this.vcstis,
                    'pis'                 : this.vpis,
                    'pisesp'              : this.vpisesp,
                    

                    // ZFM
                    'tpCredPresIBSZFM'    : this.tpCredPresIBSZFM,

                    // Compra Governamental
                    'pAliqIBSUFGov'       : this.vpAliqIBSUFGov,
                    'pAliqIBSMunGov'      : this.vpAliqIBSMunGov,
                    'pAliqCBS'            : this.vpAliqCBS,
                    
                    
                };
                let parametros      = [
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',           valor : 'rotinacrud'},
                    {parametro: 'opcrud',       valor : vself.opcrud},
                    {parametro: 'registro',     valor : JSON.stringify(registrocrud)},
                    {parametro: 'idfilial',     valor : vself.$store.state.filialpadrao.codfil},
                    {parametro: 'idusuario',    valor : vself.$store.state.usuario.id},
                    {parametro: 'codop',        valor : parseInt(this.opcrud) === 1 ? '001Z.018Z.001Z' : parseInt(this.opcrud) === 2 ? '001Z.018Z.002Z' : '001Z.018Z.003Z'},
                ];
                let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadclassesimpostos.php');
                retorno.then(function (response) {
                    loader.hide();
                    if ($.isNumeric(response.data)){
                        vself.$toastr.s('Registro processado com sucesso!', 'Informação!');
                        vself.pfiltro       = 0;
                        vself.pconteudo     = vself.vid;
                        vself.pqtd_paginas  = 1;
                        vself.mtdcancelaredicao();
                        vself.mtdcarregaclassesimpostos(1);
                    }else{
                        let tpret = response.data.substring(0,1);
                        switch (tpret) {
                            case 'I':
                                vself.$toastr.w(response.data.substring(4), 'Atenção!');
                                break;
                            case 'E': default:
                                vself.$toastr.e(response.data.substring(4), 'Erro!');
                                break;
                        }
                    }
                }).catch(function (response) {
                    loader.hide();
                    vself.$toastr.e('Erro ao processar o registo. Descrição do erro: '+response.message, 'Erro!');
                });
            }
        },
        mounted: function () {
            let vself = this;
            if (util.verificasessao(this)) {
                let loader = vself.$loading.show();
                let parametros = [
                    {parametro: 'op', valor: 'dadosusuario'},
                    {parametro: 'idclientesac', valor  : vself.$store.state.usuario.idclientesac},
                    {parametro: 'idusuario', valor: vself.$store.state.usuario.id}
                ];
                let retorno = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rotinasusuario.php');
                retorno.then(function (response) {
                    loader.hide();
                    vself.$store.commit('MUDAR_PERFIL_USUARIO', response.data.perfilusu);
                    if (parseInt(vself.$store.state.filialpadrao.plnc) < 2){
                        vself.$swal.fire({
                                            position: 'bottom-end',
                                            //icon: 'success',
                                            title: 'Atenção!',
                                            html: 'Seu plano não contempla esta funcionalidade! Favor entrar em contato com a <strong>Rillsoft Sistemas</strong> para mais informações.',
                                            showConfirmButton: false,
                                            showCloseButton: true,
                                            backdrop: false                                                
                                        }); 
                        setTimeout(function(){
                            util.gotoprincipal();
                        },4000);                                                               
                    }                    
                    if (util.opcaousuario('001Z.012Z', vself.$store.state.perfilusuario)) {
                        $('#pnlista').fadeIn(700); 
                                               
                        vself.mtdexecutapesquisa();
                        vself.mtdselect2_def();                        
                    } else {
                        vself.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
                        setTimeout(function(){
                            util.gotoprincipal();
                        },1000);
                    }
                }).catch(function (response) {
                    loader.hide();
                    console.log(response.message);
                });
            }
        },
        computed:{
            validou() {
                return this.vdescricao === '' || this.vidcfop === null;
            }
        },
        watch:{
            pagina_atual(val){
                this.mtdcarregaclassesimpostos(val);
            }
        }
    }
</script>
<style>
    .def-col-cod{
        width: 150px !important;
    }
    .lst-campos{
        font-weight: bold!important;
        color: #666666!important;
        padding: 5px 10px 5px 10px!important;
    }
</style>